"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var initTranslate = function initTranslate(langs) {
  return function (text, lang) {
    return langs[lang][text] || text;
  };
};

exports.default = initTranslate;